/* Bean Shipper blend PDP v3 behaviour (sections/product__bs-pdp-v3.liquid).
   The Liquid renders the default state in full, so a page without this script still shows every word and
   still adds the default bag. This file keeps the buy box, sticky bar and CTAs in step with the shopper's
   choices and runs the motion. Adding to the bag stays with bean-shipper.js (form[data-bs-add]).
   Money and shipping rules mirror the Liquid: snippets/bs-pdp-v3-rm and the thresholds in the data blob. */
(function () {
  'use strict';
  if (window.__bsPdpV3) return;
  window.__bsPdpV3 = 'v1';

  function fmt(c) {
    c = Math.round(c);
    var i = Math.floor(c / 100), r = c % 100;
    return 'RM' + i + (r ? '.' + (r < 10 ? '0' : '') + r : '');
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  function boot(root) {
    if (root.getAttribute('data-bp3-bound')) return;
    root.setAttribute('data-bp3-bound', '1');
    root.classList.add('is-js');
    var D;
    try { D = JSON.parse($('[data-bp3-data]', root).textContent); } catch (e) { return; }

    var form = $('form.bp3__form', root);
    var idIn = $('[data-bp3-id]', root), planIn = $('[data-bp3-plan]', root);
    var grindSel = $('[data-bp3-grind]', root);
    var buy = $('[data-bp3-buy]', root);
    var freq = $('[data-bp3-freq]', root);
    var sticky = $('[data-bp3-sticky]', root);
    var heroBtn = $('[data-bp3-hero-btn]', root);
    var phoneMq = window.matchMedia ? window.matchMedia('(max-width: 640px)') : null;

    var byId = {};
    D.variants.forEach(function (v) { byId[v.id] = v; });
    var cur = idIn ? byId[idIn.value] : D.variants[0];
    if (!cur) cur = D.variants[0];
    var st = {
      size: cur ? cur.s : 0,
      grind: cur ? cur.g : (grindSel ? grindSel.value : ''),
      mode: D.defaultPlan ? 'sub' : 'once',
      wk: 2
    };
    var planWk = {};
    D.plans.forEach(function (pl) { planWk[pl.wk] = pl.id; });
    var startPlan = D.defaultPlan || D.subDefault;
    D.plans.forEach(function (pl) { if (pl.id === startPlan) st.wk = pl.wk; });

    function variant() {
      var hit = null;
      D.variants.forEach(function (v) { if (!hit && v.s === st.size && v.g === st.grind) hit = v; });
      if (!hit) D.variants.forEach(function (v) { if (!hit && v.s === st.size) hit = v; });
      return hit;
    }
    function freqLabel() { return st.wk === 1 ? 'every week' : 'every ' + st.wk + ' weeks'; }
    function onceShip(price) {
      if (D.sg) return price >= D.ship.sgFree ? 'Ships free to Singapore' : 'RM15 courier to Singapore · free from RM200';
      return price >= D.ship.myFree ? 'Ships free in Peninsular Malaysia' : 'RM7 shipping in Peninsular Malaysia · free from RM80';
    }
    function onceShort(price) {
      if (D.sg) return price >= D.ship.sgFree ? 'ships free' : 'RM15 courier';
      return price >= D.ship.myFree ? 'ships free' : 'RM7 shipping';
    }

    function render() {
      var v = variant();
      if (!v) return;
      var sz = D.sizes[st.size] || {};
      var hasPlans = D.plans.length > 0;
      if (!hasPlans) st.mode = 'once';
      var sub = st.mode === 'sub';
      var planId = planWk[st.wk];
      var alloc = (v.sp && planId) ? v.sp[planId] : null;
      var subNow = alloc ? alloc.p : v.p;
      var payNow = sub && alloc ? (D.code ? subNow - Math.round(subNow * D.code.pct / 100) : subNow) : v.p;
      var fl = freqLabel();

      if (idIn) idIn.value = v.id;
      if (planIn) planIn.value = sub && planId ? planId : '';

      $$('[data-bp3-size]', root).forEach(function (b) {
        var on = +b.getAttribute('data-bp3-size') === st.size;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var pc = fmt(sz.pc || 0);
      setText($('[data-bp3-priceline-desk]', root), fmt(v.p) + ' · ' + sz.label + ' · about ' + sz.cups + ' cups');
      setText($('[data-bp3-priceline-phone]', root), fmt(v.p) + ' · ' + sz.label + ' · ' + pc + ' a cup');
      setText($('[data-bp3-pc]', root), pc);
      var detail = 'about ' + sz.cups + ' cups at 15g · ' + pc + ' a cup';
      if (!D.sg && v.p >= D.ship.myFree) detail += ' · ships free in Peninsular Malaysia';
      setText($('[data-bp3-detail]', root), detail);

      $$('[data-bp3-mode]', root).forEach(function (b) {
        var on = b.getAttribute('data-bp3-mode') === st.mode;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var code = D.code, subAfter = code ? subNow - Math.round(subNow * code.pct / 100) : subNow;
      var sp = $('[data-bp3-sub-price]', root);
      if (sp) {
        if (code) {
          var want = fmt(subNow) + '|' + fmt(subAfter);
          if (sp.getAttribute('data-v') !== want) {
            sp.setAttribute('data-v', want);
            sp.innerHTML = '';
            var was = document.createElement('s');
            was.textContent = fmt(subNow);
            sp.appendChild(was);
            sp.appendChild(document.createTextNode(' ' + fmt(subAfter)));
          }
        } else {
          setText(sp, fmt(subNow));
        }
      }
      setText($('[data-bp3-once-price]', root), fmt(v.p));
      setText($('[data-bp3-once-line]', root), onceShip(v.p));
      var subLine = $('[data-bp3-sub-line]', root);
      if (subLine) {
        if (code) {
          subLine.innerHTML = '';
          var cb = document.createElement('b');
          cb.textContent = code.c + ': ' + code.pct + '% off your first ' + code.n + ' deliveries';
          subLine.appendChild(cb);
          subLine.appendChild(document.createTextNode(', then ' + fmt(subNow) + ' · a fresh bag ' + fl + ' · skip or cancel any time'));
        } else if (alloc && alloc.f && alloc.f.n) {
          subLine.innerHTML = '';
          var b = document.createElement('b');
          b.textContent = fmt(alloc.f.p) + ' a bag for your first ' + alloc.f.n;
          subLine.appendChild(b);
          subLine.appendChild(document.createTextNode(' · then ' + fmt(alloc.f.then) + ' · a fresh bag ' + fl));
        } else {
          setText(subLine, 'A fresh bag ' + fl + ' · skip or cancel any time');
        }
      }
      $$('[data-bp3-wk]', root).forEach(function (c) {
        c.classList.toggle('is-on', +c.getAttribute('data-bp3-wk') === st.wk);
        c.setAttribute('aria-pressed', +c.getAttribute('data-bp3-wk') === st.wk ? 'true' : 'false');
      });
      if (freq) freq.classList.toggle('is-open', sub);
      var tog = $('[data-bp3-freq-toggle]', root);
      if (tog) {
        tog.hidden = !sub;
        setText(tog, freq && freq.classList.contains('is-phone-open') ? 'Done' : 'Change');
      }

      var plan;
      if (sub) {
        var cap = fl.charAt(0).toUpperCase() + fl.slice(1);
        plan = D.sg ? cap + ' · RM15 courier, free from RM200 · skip or cancel any time' : cap + ' · free shipping · skip or cancel any time';
      } else {
        plan = 'One-time · ' + onceShip(v.p);
      }
      setText($('[data-bp3-planline]', root), plan);

      var cta = v.a ? 'Add to bag · ' + fmt(payNow) : 'Sold out in this grind';
      $$('[data-bp3-cta]', root).forEach(function (el) {
        setText(el, cta);
        if (el.tagName === 'BUTTON') el.disabled = !v.a;
      });
      var sl = sub
        ? sz.label + ' · ' + fl + (D.sg ? '' : ' · free shipping')
        : sz.label + ' · one-time · ' + onceShort(v.p);
      setText($('[data-bp3-sticky-l]', root), sl);

      // One-time rungs follow the grind picked in the buy box.
      $$('[data-bp3-rung-id]', root).forEach(function (inp) {
        var s = +inp.getAttribute('data-bp3-rung-id'), hit = null;
        D.variants.forEach(function (x) { if (!hit && x.s === s && x.g === st.grind && x.a) hit = x; });
        if (hit) inp.value = hit.id;
      });
      setText($('[data-bp3-grind-name]', root), String(st.grind).toLowerCase());
      // Single-origin offer band names the chosen size and price.
      var oh = $('[data-bp3-offer-h]', root);
      if (oh && D.title) setText(oh, D.title + ', ' + sz.label + ', ' + fmt(v.p) + '. ' + (D.offerTail || ''));
    }

    // ---- controls ----
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-bp3-size')) { st.size = +t.getAttribute('data-bp3-size'); render(); return; }
      if (t.hasAttribute('data-bp3-mode')) { st.mode = t.getAttribute('data-bp3-mode'); render(); return; }
      if (t.hasAttribute('data-bp3-wk')) { st.wk = +t.getAttribute('data-bp3-wk'); render(); return; }
      if (t.hasAttribute('data-bp3-why')) { buy && buy.classList.add('why-open'); return; }
      if (t.hasAttribute('data-bp3-freq-toggle')) { freq && freq.classList.toggle('is-phone-open'); render(); return; }
      if (t.classList.contains('bp3__faq-q')) {
        var f = t.closest('[data-bp3-faq]'), open = !f.classList.contains('is-open');
        $$('[data-bp3-faq]', root).forEach(function (o) {
          o.classList.remove('is-open');
          var q = $('.bp3__faq-q', o); if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (open) { f.classList.add('is-open'); t.setAttribute('aria-expanded', 'true'); }
        return;
      }
      var go = t.getAttribute('data-bp3-goto');
      if (go) {
        e.preventDefault();
        if (go === 'reviews') { scrollToEl($('#bp3-reviews', root), 72); return; }
        if (t.getAttribute('data-bp3-want') === 'sub' && D.plans.length) { st.mode = 'sub'; render(); }
        scrollToEl(buy, 96);
        if (buy) {
          buy.classList.add('is-hl');
          clearTimeout(buy.__t);
          buy.__t = setTimeout(function () { buy.classList.remove('is-hl'); }, 2000);
        }
      }
    });
    if (grindSel) grindSel.addEventListener('change', function () { st.grind = grindSel.value; render(); });

    // Subscription offer code. 13 Oct 2026: this used to send cart/update.js in parallel with the
    // ajax-cart handler's cart/add.js. On a first visit (no cart yet) each request made its own cart and
    // the later reply won, so the code (3 of 4 test runs) or the new line itself (1 of 4) was lost. Now the
    // form only carries the code; the ajax-cart snippet applies it after the add succeeds, and only when the
    // cart has no other code on it (never wipes FIRSTORDER / BACKFORGOOD).
    if (form && D.code) {
      form.addEventListener('submit', function () {
        if (st.mode === 'sub' && D.plans.length) form.setAttribute('data-bs-sub-code', D.code.c);
        else form.removeAttribute('data-bs-sub-code');
      }, true);
    }

    function scrollToEl(el, off) {
      if (!el) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - off, behavior: reduce ? 'auto' : 'smooth' });
    }

    // Nav height drives the hero offset and the sticky image top.
    function navH() {
      var n = document.querySelector('header.nav');
      if (n) root.style.setProperty('--nav', n.offsetHeight + 'px');
    }
    navH();
    window.addEventListener('resize', navH, { passive: true });

    // Sticky bar: shows once the hero button has scrolled away.
    if (sticky && heroBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(heroBtn);
    }

    render();
    motion(root);
  }

  function motion(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var prog = $('[data-bp3-prog]', root), bag = $('[data-bp3-bag]', root);
    var raf = 0;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var y = window.scrollY, h = document.documentElement.scrollHeight - window.innerHeight;
        if (prog) prog.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, y / h) : 0) + ')';
        if (bag && !reduce) {
          var panel = bag.parentElement, room = panel ? Math.max(0, (panel.clientHeight - bag.offsetHeight) / 2 - 6) : 0;
          bag.style.transform = 'translateY(' + Math.min(room, y * 0.04) + 'px) scale(' + (1 - Math.min(y, 900) * 0.00004) + ')';
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (reduce || !('IntersectionObserver' in window)) return;

    // Word-mask headings: each word rises out of its own clip. Text stays at full opacity throughout.
    $$('[data-split]', root).forEach(function (h) {
      if (h.getAttribute('data-split-done')) return;
      var text = h.textContent.replace(/\s+/g, ' ').trim();
      h.setAttribute('aria-label', text);
      h.textContent = '';
      text.split(' ').forEach(function (w, i, a) {
        var o = document.createElement('span'), s = document.createElement('span');
        o.className = 'bp3__w'; o.setAttribute('aria-hidden', 'true');
        s.textContent = w; s.style.transitionDelay = (i * 55) + 'ms';
        o.appendChild(s); h.appendChild(o);
        if (i < a.length - 1) h.appendChild(document.createTextNode(' '));
      });
      h.setAttribute('data-split-done', '1');
    });

    var counts = $$('[data-count]', root);
    counts.forEach(function (el) { el.__final = el.textContent; });

    root.classList.add('bp3--motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('in');
        if (el.hasAttribute('data-count')) countUp(el);
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    $$('[data-reveal],[data-split],[data-bar],[data-count]', root).forEach(function (el) { io.observe(el); });
  }

  function countUp(el) {
    var target = parseInt(String(el.getAttribute('data-count')).replace(/,/g, ''), 10);
    if (isNaN(target) || target < 10) return;
    var t0 = performance.now(), dur = 1500;
    function step(now) {
      var p = Math.min(1, (now - t0) / dur), k = 1 - Math.pow(1 - p, 3);
      el.textContent = p < 1 ? Math.round(target * k).toLocaleString('en-US') : el.__final;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init() { $$('[data-bp3]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
